import type { PayloadAction } from '@reduxjs/toolkit';

import { PromoOfferState, SET_PROMO_OFFER } from './types';

const initialState: PromoOfferState = null;

export function promoOfferReducer(
	state = initialState,
	action: PayloadAction<PromoOfferState>,
): PromoOfferState {
	switch (action.type) {
		case SET_PROMO_OFFER:
			return action.payload;
		default:
			return state;
	}
}
